import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class TeamRoute extends Route {
  @service router;

  beforeModel(/* transition */) {
    this.router.transitionTo('operations.teams.team.check-in'); // Implicitly aborts the on-going transition.
  }
}
